function attachFeedbackForm(container) {
  const form = container.querySelector('form');
  if (!form || form.dataset.feedbackBound === 'true') return;
  form.dataset.feedbackBound = 'true';

  const submitButton = form.querySelector('button[type="submit"]');

  const setSubmitting = (isSubmitting) => {
    if (submitButton) {
      submitButton.disabled = isSubmitting;
      submitButton.setAttribute('aria-disabled', String(isSubmitting));
    }
    container.classList.toggle('is-submitting', isSubmitting);
  };

  form.addEventListener('submit', () => {
    try {
      const currentUrl = new URL(window.location.href);
      const view = currentUrl.searchParams.get('view');
      if (view) {
        window.sessionStorage.setItem('wuffesFeedbackReturnView', view);
        window.sessionStorage.removeItem('wuffesFeedbackReturnPath');
      } else {
        window.sessionStorage.setItem('wuffesFeedbackReturnPath', currentUrl.pathname);
        window.sessionStorage.removeItem('wuffesFeedbackReturnView');
      }
    } catch (e) {}

    setSubmitting(true);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.feedback-form').forEach((container) => attachFeedbackForm(container));
});

